import moment from "moment";

const momentTz = require('moment-timezone');

const userTimezone = momentTz.tz.guess() === "Asia/Calcutta" ? "Asia/Kolkata" : momentTz.tz.guess();

export const getAllTimeZones = () => {
    return momentTz.tz.names();
}

export const getUserLocalTimeZone = () => {
    return userTimezone
}

export const utcLabel = (timezone) => {
    if (!timezone)
        throw new Error("Missing required argument: timezone");

    return momentTz.tz(timezone).format("Z")
}

export const getTimeStamp = (date) => {
    const dateString = date ? moment(date).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY");
    const currentDate = dateString.split('-');
    const newDate = new Date(currentDate[2], currentDate[1] - 1, currentDate[0]);
    return newDate.getTime();
}

export const getDateTimeStamp = (date) => {
  const timeStamp = date ? moment(date).valueOf() : moment.valueOf();
  return timeStamp;
};

export const isJoinReady = (startTime, endTime, repeats) => {
  const now = new Date();
  const upto = new Date(endTime * 1000); // Convert seconds to milliseconds
  const start = new Date(startTime * 1000); // Convert seconds to milliseconds

  if (repeats === "daily" && upto > now) {
    // Get the time portion of the date in today's context
    const timeNow = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const timeStart = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      start.getUTCHours(),
      start.getUTCMinutes(),
      start.getUTCSeconds()
    );
    const secondsRemaining = (timeStart - timeNow) / 1000; // Convert milliseconds to seconds
    return secondsRemaining > -600 && secondsRemaining < 10;
  }
  return false;
};
